<style lang="less" scoped>
.flfwpl{display: flex;flex-direction: column;width: 1200px; margin: 10px auto;}
.table {border-collapse: collapse;width: 100%;margin-top: 10px;}
tr, td {border: 1px solid #dfdcdc;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.left{width: 200px;}
ul{list-style: none;width:985px;margin-left: 176px;}
li{display: flex; border: 1px solid #dfdcdc;margin: 10px auto;height: 200px;
.left{width: 210px;border: 1px solid #dfdcdc;}
img{width:100px;height: 120px;margin-top: 20px;}
.right{position: relative;padding: 10px;flex-grow: 1;text-align: left;}
.addtime{position: absolute;left: 10px;bottom: 10px;}}
.block{margin-top: 20px;}
</style>

<template>
  <div class="flfwpl" id="flfwpl">
    <table>
      <tr>
        <td class="left" rowspan="2">
          <img src="static/images/官网首页/头像.png" style="width:200px;height: 220px;" />
          <p>{{ username }}</p>
        </td>
        <td class="left" >咨询内容</td>
        <td class="right">
          <el-input type="textarea" v-model="question" :rows="5" style="font-size: 16px;"></el-input>
        </td>
      </tr>
      <tr>
        <td class="left">相关图片</td>
        <td>
          <img :src="thumb" style="width: 300px;height: 200px;" />
        </td>
      </tr>
    </table>
    <p v-if="noReply" style="margin: 50px auto; font-size: 24px;">该问题暂无回复，看看其他问题吧！</p>
    <ul>
      <li v-for="(item, index) in replyList" :key="index">
        <div class="left">
          <img src="static/images/官网首页/头像.png" />
          <p class="replier">{{ item.replier }}</p>
        </div>
        <div class="right">
          <p class="reply">{{ item.reply }}</p>
          <p class="addtime">回复时间：{{ item.addtime * 1000 | formatTime() }}</p>
        </div>
      </li>
      <div class="block" v-if="!noReply">
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange(this.form.count)"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="countSum">
        </el-pagination>
      </div>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽
 * 法律服务评论页面
 */
import filters from '../method/filter'
export default {
  mixins: [filters],
  data()
  {
    return {
      question: '',
      thumb: '',
      replyList: [],
      noReply: false,
      username: '',
      count: 10,
      pageSize: 10,
      currentPage: 1,
      countSum: null
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        if (localStorage.getItem('username'))
        {
          let paras = {cmd: 'query', _major: 11, _minor: 28, _exp: `username = '${localStorage.getItem('username')}'`}
          window.post.getPost(paras).then((ret) =>
          {
            if (ret.length === 1)
              this.username = ret[0].passport
          })
        }
        this.getList(+nval.query.id)
      },
      immediate: true
    }
  },
  methods: {
    // 获取数据
    getList(num)
    {
      let count = this.count
      let currentPage = this.currentPage
      let paras = {cmd: 'query', _major: 11, _minor: 63, _exp: 'id=?', types: 'i', vals: num, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.question = ret[0].content
        this.thumb = ret[0].thumb ? ret[0].thumb : 'static/images/moren.jpg'
      })
      let paras1 = {cmd: 'queryUnion', _major: 11, _minor: 64, tables: 'A;B:11,63', cols: 'A:*;B:content,thumb', _exp: `A.glid = ${num} and` + ' A.glid=B.id', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'addtime DESC'}
      window.post.getPost(paras1).then((ret) =>
      {
        this.countSum = ret[0].total
        if (ret[0].data.length !== 0)
        {
          this.replyList = ret[0].data
          this.noReply = false
        }
        else
          this.noReply = true
      })
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    search()
    {
      this.getList()
      this.handleSizeChange(this.count)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/FlfwPL.vue